import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Checkbox, FormControlLabel, IconButton, InputAdornment } from "@mui/material";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import countries from "../../app/countries";
import { SimpleDetail } from "../../common/components/SimpleDetail";
import placeholderImage from "../../mocks/imgs/b.jpeg";

import { editMachine, selectCurrentMachine } from "./machinesSlice";
import { countrySelector } from "../../common/components/CountrySelector";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export const MachineDetail = ({ header, onMappingsClick }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);

  const {
    title = "",
    model = "",
    dsn = "",
    country = "" /*, content = {}*/,
    ela = "",
  } = useSelector(selectCurrentMachine);
  // const { imageUrl = '' } = content;

  const open = !!anchorEl;
  const handleClickCountry = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseCountry = (event) => {
    setAnchorEl(null);
    if (event.target.id) {
      handleEdit({ target: { id: "country", value: event.target.id } });
    }
  };

  const handleEdit = (event) => {
    let target = event.target.id;
    let value = event.target.value;
  

    if (target === "ela") {
     value=event.target.checked;
    }

    // if(target === "imageUrl"){
    //   target = "content";
    //   value = {...content, imageUrl: value };
    // }

    dispatch(
      editMachine({
        [target]: value,
      })
    );
  };

  return (
    <>
      <SimpleDetail
        header={header}
        children={
          <>
            <Item
              elevation={0}
              sx={{ height: 250, display: "flex", justifyContent: "center" }}
            >
              <Box>
                <img
                  src={placeholderImage}
                  alt="image"
                  style={{ width: "250px", height: "250px" }}
                />
              </Box>
            </Item>
            <Item elevation={0} sx={{ height: 50 }}>
              <TextField
                required
                error={!model}
                fullWidth
                id="model"
                label="Name"
                variant="outlined"
                value={model}
                onChange={handleEdit}
              />
            </Item>
            <Item elevation={0} sx={{ height: 50 }}>
              <TextField
                required
                error={!title}
                fullWidth
                id="title"
                label="Code"
                variant="outlined"
                value={title}
                onChange={handleEdit}
                InputProps={{
                  endAdornment: countrySelector(country, handleClickCountry),
                }}
              />
            </Item>
            <Box display="flex">
              <Item elevation={0} sx={{ height: 50, width: 600 }}>
                <TextField
                  required
                  error={!dsn}
                  fullWidth
                  id="dsn"
                  label="Model"
                  variant="outlined"
                  value={dsn}
                  onChange={handleEdit}
                />
              </Item>
              <Item elevation={0} sx={{ height: 50, ml: "20px", mt: "5px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="ela"
                      error={!ela}
                      fullWidth
                      id="ela"
                      checked={ela}
                      onChange={handleEdit}
                    />
                  }
                  label="Ela"
                  variant="outlined"
                />
              </Item>
            </Box>
            <Item elevation={0} sx={{ height: 50 }}>
              <Button
                fullWidth
                variant="contained"
                endIcon={<ArrowDownwardIcon />}
                sx={{
                  "& .MuiButton-endIcon": {
                    position: "relative",
                    bottom: "1px",
                  },
                  py: 1.7,
                }}
                onClick={onMappingsClick}
              >
                IoT Mappings
              </Button>
            </Item>

            <Menu
              id="country select"
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseCountry}
            >
              {countries.map((ct) => (
                <MenuItem
                  id={ct.value}
                  key={ct.name}
                  selected={ct.value === country}
                  onClick={handleCloseCountry}
                >
                  <ct.icon style={{ marginRight: "10px" }} />
                  {ct.name}
                </MenuItem>
              ))}
            </Menu>
          </>
        }
      />
    </>
  );
};
